import PropTypes from 'prop-types';
import { ColourIndicator } from '../../../../common/components';

export default function TrustLegend({ title, showStatus = false }) {
  return (
    <ul>
      <li className="title">{title}</li>
      {showStatus ? (
        <>
          <li>
            <ColourIndicator label="In Progress" colour="#1DE06B" />
          </li>
          <li>
            <ColourIndicator label="Closed" colour="#25A72B" />
          </li>
          <li>
            <ColourIndicator label="Defaulted" colour="#F8A038" />
          </li>
          <li>
            <ColourIndicator label="Cancelled" colour="#FA9898" />
          </li>
        </>
      ) : null}
    </ul>
  );
}

TrustLegend.propTypes = {
  title: PropTypes.string.isRequired,
  showStatus: PropTypes.bool,
};
